import { Component, Input }     from '@angular/core';
import { Router }               from '@angular/router';
//import { OrgAuthService }       from '../auth/org/orgauth.service';
import { Referral }             from '../_models/referral';
//import { ShareReferralService } from '../_services/index';

@Component({
  selector: 'referrernetwork-list',
  template: 
  `
    <span  class="handicon list-group-item"  >
      <a  class="fa fa-user fa-lg mybtn" aria-hidden="true"></a> <a   ng-class="hand wordWrap"><b>( {{ referrerNetwork.Email }} )  {{ referrerNetwork.Prefix }} {{ referrerNetwork.FirstName }} {{ referrerNetwork.LastName }} of  {{referrerNetwork.InvitedDate}}</b></a>
    </span>         

    `
})


export class ReferrerNetworkListDirective {

  @Input()
  referrerNetwork: any;
  
  constructor(
    //private router: Router, 
    //private authOrg: OrgAuthService, 
    //private shareReferral:ShareReferralService
    ) {}

  /*viewReferral(){
    if (this.referrerNetwork.referralid != ""){ //alert(this.referral.referralid);
        //this.router.navigate(['/report-generator', { id: this.referral.referralid} ]);      
        this.shareReferral.saveSelectedReferral(this.referrerNetwork); 
        this.router.navigate(["/org/org-view-referral"]);           
        //this.router.navigate(["ind-add-referrers", this.referral.referralid]);   
    }else{
        this.router.navigate(["/org/org-home"]);
    }*/
    
  }

  


